import React from "react";
import DescriptionList from "@comm/DescriptionList";

const { Description } = DescriptionList;

const CardBase = ({ customInfo }) => (
  <DescriptionList size="large" col={3}>
    <Description term="公司名称">{customInfo.customName}</Description>
    <Description term="联系人员">{customInfo.contactName}</Description>
    <Description term="入驻状态">
      {customInfo.isMoveOut === 0 ? "入驻" : "迁出"}
    </Description>
    <Description term="项目名称">{customInfo.projectName}</Description>
    <Description term="联系电话">{customInfo.contactTel}</Description>
  </DescriptionList>
);

export default CardBase;



// WEBPACK FOOTER //
// ./src/components/incubator/custom/detail/CardBase.js